import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dnslytics = defineConnector({
  identifier: "dnslytics",
  name: "DNSlytics",
  tagLine: "DNS, subnet, and domain intelligence",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://api\\.dnslytics\\.net/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get a DNSlytics API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [DNSlytics API access](https://dnslytics.com/api/) and purchase or activate API credits for your account.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "DNSlytics API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.dnslytics.net/v1/accountinfo",
  },
});
